import { render, staticRenderFns } from "./AdministratorBase.vue?vue&type=template&id=0e0bfd71&scoped=true&"
import script from "./AdministratorBase.vue?vue&type=script&lang=js&"
export * from "./AdministratorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0bfd71",
  null
  
)

export default component.exports